<template>
  <header class="topnavbar-wrapper">
    <nav class="navbar topnavbar">
      <div class="navbar-header">
        <a class="navbar-brand" href="/tenders">
          <div class="brand-logo">
            <h4 class="text-white m-0">{{ $t('navbar.site-name') }}</h4>
          </div>
          <div class="brand-logo-collapsed">
            <h4 class="text-white m-0">{{ $t('global.client-name-short') }}</h4>
          </div>
        </a>
      </div>

      <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
          <a class="nav-link d-none d-md-block d-lg-block d-xl-block cursor-pointer" @click="toggle_aside_collapsed">
            <em class="fas fa-bars"></em>
          </a>
          <a class="nav-link sidebar-toggle d-md-none" @click="toggle_aside_collapsed">
            <em class="fas fa-bars"></em>
          </a>
        </li>
        <li class="nav-item d-none d-md-block">
          <a class="nav-link cursor-pointer" id="user-block-toggle" @click="toggle_user_block">
            <em class="icon-user"></em>
          </a>
        </li>
        <li class="nav-item dropdown dropdown-list">
          <a
            class="nav-link dropdown-toggle dropdown-toggle-nocaret align-middle cursor-pointer"
            data-toggle="dropdown"
            @click="set_language('et-EE')"
            v-if="language==='et-EE'"
          >
            <img src="/static/et.png" height="14" alt="Eesti" title="Eesti"><span class="d-none d-sm-inline ml-1">Eesti</span>
          </a>
          <a
            class="nav-link dropdown-toggle dropdown-toggle-nocaret align-middle cursor-pointer"
            data-toggle="dropdown"
            @click="set_language('ru-RU')"
            v-if="language==='ru-RU'"
          >
            <img src="/static/ru.png" height="14" alt="Русский" title="Русский"><span class="d-none d-sm-inline ml-1">Русский</span>
          </a>
          <a
            class="nav-link dropdown-toggle dropdown-toggle-nocaret align-middle cursor-pointer"
            data-toggle="dropdown"
            @click="set_language('en-US')"
            v-if="language==='en-US'"
          >
            <img src="/static/en.png" height="14" alt="English" title="English"><span class="d-none d-sm-inline ml-1">English</span>
          </a>

          <div class="dropdown-menu animated flipInX">
            <div class="dropdown-item">
              <div class="list-group">

                <div class="list-group-item list-group-item-action" v-if="language!=='et-EE'" @click="set_language('et-EE'); refreshPage();">
                  <div class="media">
                    <div class="media-body">
                      <a class="m-0 link-unstyled align-middle" >
                        <img src="/static/et.png" height="14" alt="Eesti" title="Eesti"> Eesti
                      </a>
                    </div>
                  </div>
                </div>

                <div class="list-group-item list-group-item-action" v-if="language!=='ru-RU'" @click="set_language('ru-RU'); refreshPage();">
                  <div class="media">
                    <div class="media-body">
                      <a class="m-0 link-unstyled align-middle" >
                        <img src="/static/ru.png" height="14" alt="Русский" title="Русский"> Русский
                      </a>
                    </div>
                  </div>
                </div>

                <div class="list-group-item list-group-item-action" v-if="language!=='en-US'" @click="set_language('en-US'); refreshPage();">
                  <div class="media">
                    <div class="media-body">
                      <a class="m-0 link-unstyled align-middle" >
                        <img src="/static/en.png" height="14" alt="English" title="English" class=""> English</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </li>
      </ul>
<!--      <ul class="navbar-nav mr-auto flex-row">-->
<!--        <li class="nav-item d-md-block px-2 text-white">{{ $t('maintainance-text') }}</li>-->
<!--      </ul>-->
      <ul class="navbar-nav flex-row">
        <li class="nav-item d-md-block">
          <a class="nav-link cursor-pointer" @click="log_out">
            <em class="icon-logout"></em> <span class="d-none d-sm-inline ml-1">{{ $t('navbar.log-out') }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  data () {
    return {
      language: this.$store.getters.language
    }
  },
  mounted () {
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    refreshPage(){
      window.location.reload();
    },
    set_language (lang) {
      this.$store.dispatch('setLanguage', lang)
      this.language = lang
      this.$i18n.locale = lang

    },
    log_out () {
      this.$store.commit('log_out')
      this.$router.push({path: '/'})
    },
    toggle_aside_collapsed () {
      this.$store.dispatch('setAsideCollapsed', this.$store.getters.aside_collapsed === 'yes' ? 'no' : 'yes')
      window.dispatchEvent(new Event('resize'))
    },
    toggle_user_block () {
      this.$store.dispatch('setShowUserBlock', this.$store.getters.show_user_block === 'yes' ? 'no' : 'yes')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue